<template>
  <div id="app-project">
    <div class="project-box">
      <div class="project-top">
        <h3 class="animated fadeInLeft">爱眼公益行</h3>
        <!-- <router-link  :to="{path:'/pubIndex',query:{cid:3}}" >  -->
        <div class="more-box animated fadeInRight" style="cursor:pointer" @click="goMore">
          <h6>更多</h6>
          <p>more</p>
        </div>
        <!-- </router-link> -->
        <div class="border-box animated fadeInUpBig"></div>
      </div>
      <div class="project-bottom">
        <ul>
          <li v-for="(item,index) in newList" :key="index">
            <div class="project-col" @click="goto(item.id)">
              <div
                v-if="item.news_pic_url"
                class="img-box"
                :style="{background: 'url(' + item.news_pic_url + ') no-repeat center', backgroundSize:'cover'}"
              ></div>
              <div
                v-else
                class="img-box"
                :style="{background: 'url(' + error + ') no-repeat center', backgroundSize:'cover'}"
              ></div>
              <div class="content-box">
                <h5>{{item.news_title}}</h5>
              </div>
            </div>
          </li>
        </ul>
        <!-- <el-row :gutter="20"> -->
        <!-- </el-col>
        </el-row>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      error: require("../../assets/images/default.png"),
      classShow: true,
      classHide: false,
      newList: [],
      webInfo: {}
    };
  },
  methods: {
    goMore() {
      if (this.webInfo.new_more > 0) {
        this.$router.push({
          path: "/pubIndex",
          query: { cid: this.webInfo.new_more }
        });
      }
    },
    goto(id) {
      this.$router.push({
        name: "pubDetails",
        query: {
          id: id
        }
      });
    }
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },

  watch: {
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate: true
    }
  },
  created() {
    this.$db.post(this.$db.config.getNewsIndexUrl, {}).then(res => {
      if (res.code == 200) {
        this.newList = res.data;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
#app-project {
  width: 100%;
  margin: 20px 0;
  margin-top: 0;
}
.project-box {
  width: 1300px;
  margin: 0 auto;
  .project-top {
    position: relative;
    margin-bottom: 60px;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .more-box {
      position: absolute;
      right: 0;
      top: 20px;
      > p {
        font-size: 12px;
        color: #333333;
      }
      > h6 {
        font-size: 14px;
        color: #333333;
      }
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
      animation-delay: 0.3s;
    }
  }
  .project-bottom {
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    width: 100%;
    > ul {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      > li {
        list-style: none;
        width: 310px;
        margin-right: 20px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .project-col {
          cursor: pointer;
          margin-bottom: 26px;
          transition: all 0.2s linear;
          &:hover {
            transform: scale(1.05);
            box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
            .content-box {
              background-color: #c30d23;
              transition: all 0.2s linear;
              > h5 {
                color: #fff;
              }
            }
          }
          .img-box {
            width: 100%;
            height: 232px;
            > img {
              width: 100%;
              height: 100%;
            }
          }
          .content-box {
            padding: 20px 10px 20px 9px;
            > h5 {
              font-size: 18px;
              color: #333;
              font-weight: 500;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            > ul {
              > li {
                list-style: none;
                margin-top: 6px;
                > span {
                  font-size: 14px;
                  color: #999;
                }
                > i {
                  font-style: normal;
                  font-size: 16px;
                  color: #c30d23;
                  font-weight: 700;
                }
                > b {
                  font-size: 16px;
                  // font-weight: normal;
                  color: #333;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/home_welfare.vue